import type React from 'react';
import { createContext, useContext } from 'react';

type ElementPositionContextType = {
  elementPosition: string;
};

const ElementPositionContext = createContext<
  ElementPositionContextType | undefined
>(undefined);

export const ElementPositionProvider: React.FC<{
  position: string;
  children: React.ReactNode;
}> = ({ position, children }) => (
  <ElementPositionContext.Provider value={{ elementPosition: position }}>
    {children}
  </ElementPositionContext.Provider>
);

export const useElementPosition = (): string => {
  const context = useContext(ElementPositionContext);
  if (!context) {
    throw new Error(
      'useElementPosition must be used within an ElementPositionProvider',
    );
  }
  return context.elementPosition;
};
